import {Injectable} from '@angular/core';
import {HttpInterceptor, HttpRequest, HttpHandler, HttpEvent} from '@angular/common/http';
import {Observable} from 'rxjs';
import {UserService} from "../service/user.service";

@Injectable()
export class UUIDInterceptor implements HttpInterceptor {

  // Elenco delle URL da escludere (può essere endpoint completi o porzioni)
  private domain: string[] = [
    'https://andriasmart-be-stage.fivelab.it',
    'https://andriasmart-be.fivelab.it',
    'localhost'
  ];

  constructor(private userService: UserService) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    // Verifica se la richiesta è in whitelist
    const isContain = this.domain.some(url => req.url.includes(url));

    if (!isContain) {
      return next.handle(req); // Non aggiunge il token
    }

    if (this.userService.uuid) {


      const cloned = req.clone({
        setHeaders: {
          uuid: this.userService.uuid
        }
      });
      return next.handle(cloned);
    }
    return next.handle(req);
  }
}
